import React, { useEffect, useRef, useState } from "react";
import Heading from "../Highlightedheading/Heading";
import Button from "../Buttons/Button";
import CustomPlaybutton from "../Buttons/CustomPlaybutton";
import { useNavigate } from "react-router-dom";
import "./tvcs.css";
import MobileSlider from "../CostomSlider/VideoSlider";
import Aos from "aos";
import YoutubeEmbed from "./YoutubeEmbed";
import { tvcsVideos } from "../../data/data";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useWindowSize } from "react-use";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

const Tvcsyt = () => {
  const { width } = useWindowSize();
  const scrollerRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setHeight(scrollerRef?.current?.childNodes[0]?.offsetHeight);
  }, []);

  const divideCount = Math.ceil(tvcsVideos?.length / 8);
  const sortedVideos = [];
  for (let i = 0; i < divideCount; i++) {
    sortedVideos[i] = tvcsVideos?.slice(i * 8, 8 * (i + 1));
  }

  return (
    <section className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] w-full h-full relative">
      <div className="">
        <div className="flex items-center justify-between relative">
          <Heading headingText="TVCS" />
          <Button
            buttonText={"VIEW ALL"}
            customCss={"md:pt-9"}
            onClick={() => navigate("/commercials")}
          />
        </div>

        {width >= 992 ? (
          <div
            // data-aos="fade-up"
            className="space-y-4 mt-8 overflow-y-scroll hide-scrollbar"
            ref={scrollerRef}
            style={{ height: height }}
          >
            {sortedVideos?.map((videoList, i) => {
              const leftVideos = videoList
                ?.slice(0, 8)
                ?.filter((_, i) => i % 3 === 0);

              const rightVideos = videoList
                ?.slice(0, 8)
                ?.filter((_, i) => i % 3 !== 0);

              // const leftGridSetting =
              //   leftVideos.length === 3
              //     ? "grid-rows-[400px,200px,400px] 3xl-plus:grid-rows-[554px,348px,554px]"
              //     : leftVideos.length === 2
              //     ? "grid-rows-[400px,200px] 3xl-plus:grid-rows-[554px,348px]"
              //     : "grid-rows-[400px] 3xl-plus:grid-rows-[554px]";

              // const rightGridSetting =
              //   rightVideos.length >= 5
              //     ? "grid-rows-[290px,310px,400px] 3xl-plus:grid-rows-[415px,486px,554px]"
              //     : rightVideos.length >= 3
              //     ? "grid-rows-[290px,310px] 3xl-plus:grid-rows-[415px,486px]"
              //     : "grid-rows-[275px] 3xl-plus:grid-rows-[415px]";

              const leftGridSetting =
                leftVideos.length === 3
                  ? "grid-rows-[225px,150px,225px] lg2-plus:grid-rows-[300px,170px,300px] xl:grid-rows-[400px,200px,400px] 2xl-plus:grid-rows-[554px,348px,555px]  3xl-plus:grid-rows-[623px,391px,624px]"
                  : leftVideos.length === 2
                  ? "grid-rows-[225px,150px] lg2-plus:grid-rows-[300px,170px] xl:grid-rows-[400px,200px] 2xl-plus:grid-rows-[554px,348px] 3xl-plus:grid-rows-[623px,391px]"
                  : "grid-rows-[225px] lg2-plus:grid-rows-[300px] xl:grid-rows-[400px] 2xl-plus:grid-rows-[555px] 3xl-plus:grid-rows-[623px]";

              const rightGridSetting =
                rightVideos.length >= 5
                  ? "grid-rows-[187.5px,187.5px,225px] lg2-plus:grid-rows-[235px,235px,300px] xl:grid-rows-[290px,310px,400px] 2xl-plus:grid-rows-[450px,450px,555px] 3xl-plus:grid-rows-[506px,506px,624px]"
                  : rightVideos.length >= 3
                  ? "grid-rows-[187.5px,187.5px] lg2-plus:grid-rows-[235px,235px] xl:grid-rows-[290px,310px] 2xl-plus:grid-rows-[450px,450px] 3xl-plus:grid-rows-[506px,506px]"
                  : "grid-rows-[187.5px] lg2-plus:grid-rows-[235px] xl:grid-rows-[290px] 2xl-plus:grid-rows-[450px] 3xl-plus:grid-rows-[506px]";

              return (
                <div
                  className="grid grid-cols-1 md:grid-cols-3 gap-y-4 md:gap-4"
                  key={`video-list-${i}`}
                >
                  <div className={`grid ${leftGridSetting} gap-4`}>
                    {leftVideos?.map((video, i) => (
                      <div className="w-full h-full" key={`yt-video-${i}`}>
                        <YoutubeEmbed
                          id={video.id}
                          videoId={video.videoId}
                          thumbnail={video.thumbnail}
                          iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                          iframecss="w-full h-full"
                          isHoveredIndex={isHoveredIndex}
                          setIsHoveredIndex={setIsHoveredIndex}
                        />
                      </div>
                    ))}
                  </div>
                  <div
                    className={`col-span-2 grid grid-cols-2 ${rightGridSetting} gap-4`}
                  >
                    {rightVideos?.map((video, i) => (
                      <div
                        className={`w-full h-full ${
                          i === 4 ? "col-span-full" : ""
                        }`}
                        key={`yt-video-${i}`}
                      >
                        <YoutubeEmbed
                          id={video.id}
                          videoId={video.videoId}
                          thumbnail={video.thumbnail}
                          iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                          iframecss="w-full h-full"
                          isHoveredIndex={isHoveredIndex}
                          setIsHoveredIndex={setIsHoveredIndex}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="relative mt-4">
            <Swiper
              slidesPerView={1}
              spaceBetween={7}
              centeredSlides={false}
              loop={true}
              grabCursor={false}
              navigation={{
                nextEl: ".next_arrow",
                prevEl: ".prev_arrow",
              }}
              modules={[Navigation]}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              className="!w-full !h-full"
            >
              {tvcsVideos?.map((video, i) => (
                <SwiperSlide key={`slide-${i}`}>
                  <div
                    className="w-full h-full aspect-square"
                    key={`yt-video-${i}`}
                  >
                    <YoutubeEmbed
                      videoId={video.videoId}
                      thumbnail={video.thumbnail}
                      iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                      iframecss="w-full h-full"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* <FaChevronLeft className="prev_arrow absolute top-1/2 -translate-y-1/2 left-0 text-white z-[10] text-[30px] md:text-[40px] stroke-1" />
            <FaChevronRight className="next_arrow absolute top-1/2 right-0 -translate-y-1/2 text-white z-[10] text-[30px] md:text-[40px] stroke-1" /> */}
            <GoChevronLeft className="prev_arrow absolute top-1/2 -translate-y-1/2 left-0 text-white z-[10] text-[30px] md:text-[40px]" />
            <GoChevronRight className="next_arrow absolute top-1/2 right-0 -translate-y-1/2 text-white z-[10] text-[30px] md:text-[40px]" />
          </div>
        )}
      </div>
    </section>
  );
};

export default Tvcsyt;
